import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1aa4252b&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=1aa4252b&lang=scss&scoped=true&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4252b",
  null
  
)

export default component.exports